
import { ActionType, CHAINTYPES, merchantStateType, reducerStoreType } from "./types";

const defaultState = {
  merchantInfo: {
    name: '',
    currency: '',
    exchangeFlag: 0,
    exchangeRate: 0,
    markupRate: 0,
    exchangeWithdrawFlag: 0,
    orgCurrency: '',
    country: '',
    feeType: 0,
    qrodeImg: '',
    qrcodeAlipayImg: '',
    qrcodeWechatImg: '',
    feeWallet: {},
    selectWallet: {},
    orgList: [],
    walletList: [],
    wallet: '',
    feeRate: 0,
    productList: [],
    totalAmt: 0,
    settledAmt: 0,
    unsettledAmt: 0,
    orgTotalAmt: 0,
    orgSettledAmt: 0,
    orgUnsettledAmt: 0,
    feeAmt: 0,
    bankAmt: 0,
    chainType: CHAINTYPES.SINGLE,
    accoutList: []
  },
  storeList: []
}


const merchant = (state: merchantStateType = defaultState, action: ActionType<any>) => {
  switch (action.type) {
    case 'SET_MERCHANT_INFO':
      return {
        ...state,
        merchantInfo: action.payload
      }
    case 'SET_STORE_LIST':
      return {
        ...state,
        storeList: action.payload.list
      }
    case 'SET_FEE_TYPE':
      return {
        ...state,
        merchantInfo: {
          ...state.merchantInfo,
          feeType: action.payload.feeType
        }
      }
    case 'SET_MARK_UP_RATE':
      return {
        ...state,
        merchantInfo: {
          ...state.merchantInfo,
          markupRate: action.payload.markupRate
        }
      }
    default:
      return state;
  }
}

export const merchantInfo = (state: reducerStoreType) => (state.merchant.merchantInfo)
export const storeList = (state: reducerStoreType) => (state.merchant.storeList)

export default merchant